
import { CulturalList } from '../../helper/CulturalActivities';
import styled from 'styled-components'
import CulturalCard from './cultural/CulturalCard';

const CulturalActivities = () => {
  return (
    <Wrapper>
      <h1>Sports Activities</h1>
      <section className="container">
        {CulturalList.map((sport) => (
          <CulturalCard key={sport.id} {...sport} />
        ))}
      </section>
    </Wrapper>
  );
};
const Wrapper = styled.section`
.container{
  margin-top:100px;
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  justify-content: center !important;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    width: fit-content;
    margin: 100px auto;
  }
}
    
`
export default CulturalActivities;